module.exports = __webpack_public_path__ + "img/Yoshi.2e90957b.png";